import { Component, Input, Output, EventEmitter } from '@angular/core';

import { DataManager } from "techlify-ng";
import { AlertService } from "techlify-ng";
import { RequestErrorService } from "techlify-ng";

import { Organization } from "./organization.model";

/**
 * Controller used to edit a Place Of Employment
 * 
 * @author Floyd Kissoon
 * @since 20180703
 */
@Component({
    selector: 'organization-edit',
    templateUrl: "./organization-form.html"
})
export class OrganizationEditComponent
{

    @Input() organization: Organization;
    @Output() onSave = new EventEmitter<Organization>();
    private isWorking = false;
    
    constructor(private dataManager: DataManager, private alertService: AlertService,
    private errorHandler: RequestErrorService) { }

    save()
    {
        this.isWorking = true;
        this.dataManager.PUT("api/organization/" + this.organization.id, this.organization).then(
            res =>
            {
                this.onSave.emit(res.organization);
                this.alertService.addAlert(res.message, "success");
                this.isWorking = false;
            },
            error =>
            {
                this.errorHandler.handleError(error);
                this.isWorking = false;
            }
        );
    }
}